import { ChangeDetectionStrategy, Component, Input, OnChanges, ViewChild } from '@angular/core';
import {PaymentSIAConfiguration, PaymentSIAItem } from 'models';

@Component({
  selector: 'sb-redirecting-sia-payment',
  templateUrl: './redirecting-sia-payment.component.html',
  styleUrls: ['./redirecting-sia-payment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class RedirectingSiaPaymentComponent implements OnChanges {
  @Input() paymentConfigurationUrl;
  @Input() paymentSIAConfigurationData: PaymentSIAItem[];
  @Input() shouldBeSubmitted: boolean;
  @ViewChild('paymentForm', { static: false }) paymentForm;
  public urlBack = document.location.href;


  ngOnChanges() {
    if (this.shouldBeSubmitted) {
      this.paymentForm.nativeElement.submit();
    }
  }

}

